import { render, staticRenderFns } from "./LeftMenuItem.vue?vue&type=template&id=df602a20&scoped=true&"
import script from "./LeftMenuItem.vue?vue&type=script&lang=js&"
export * from "./LeftMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./LeftMenuItem.vue?vue&type=style&index=0&id=df602a20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df602a20",
  null
  
)

export default component.exports